/*
 * Toolworld – flyttebånd, menupanel og kurv-boble (byggemanual v1.1, afsnit 4). Fase 1.
 * Indlæses på alle sider af snippets/tw-scripts.liquid (defer). Markup: sections/tw-flyttebaand.liquid,
 * sections/tw-menupanel.liquid, snippets/tw-header-main.liquid og sections/header.liquid (TW-KERNE).
 *
 * Menupanelet: hele træet ligger i HTML'en. "Stien" er listen af åbne kolonner (rod → L2 → L3).
 * Desktop (≥ 1024 px): alle kolonner i stien vises side om side. Mobil/tablet: kun den sidste, der glider ind.
 * Klik åbner næste niveau (ingen hover). Esc, krydset og baggrunden lukker. Fokus holdes i panelet
 * og sendes tilbage til Menu-knappen, når panelet lukkes. Piletaster: op/ned i listen, højre åbner, venstre tilbage.
 */
(function () {
  'use strict';

  /* ---------- 4.1 Flyttebånd ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tw-flyttebaand-luk]');
    if (!btn) return;
    var band = btn.closest('[data-tw-flyttebaand]');
    if (!band) return;
    band.hidden = true;
    try {
      localStorage.setItem(band.getAttribute('data-tw-flyttebaand'), 'lukket');
    } catch (err) {}
  });

  /* ---------- Kurv: boblen skjules ved 0, og desktop-minikurven åbner, når antallet stiger ---------- */
  function initKurv() {
    var counts = document.querySelectorAll('.cart_count');
    if (!counts.length || !window.MutationObserver) return;
    var desktop = window.matchMedia('(min-width: 799px)');
    var last = parseInt(counts[0].textContent, 10) || 0;
    var timer = null;
    var check = function () {
      var n = parseInt(counts[0].textContent, 10) || 0;
      // Alle tællere, også dem Turbo har klonet ind efter indlæsning (sticky header, mobilkurv)
      document.querySelectorAll('.cart_count').forEach(function (el) {
        el.classList.toggle('is-empty', (parseInt(el.textContent, 10) || 0) === 0);
      });
      // Turbo åbner minikurven i ".top-bar .cart-container". På desktop rammer det nu kun mobilheaderens
      // (skjulte) kurv, fordi desktopheaderen ikke har .top-bar længere (tw-topbar). Åbn den synlige i stedet.
      if (n > last && desktop.matches && !document.querySelector('.header .cart-container.active_link')) {
        var cart = document.querySelector('.header .tw-hicon-cart');
        var mobil = document.querySelector('#header .cart-container.active_link');
        if (mobil) mobil.classList.remove('active_link');
        if (cart) cart.classList.add('active_link');
      }
      last = n;
    };
    var obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(check, 50);
    });
    counts.forEach(function (el) {
      obs.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- 4.4–4.6 Menupanel ---------- */
  function initMenupanel() {
    var mp = document.querySelector('[data-tw-mp]');
    if (!mp) return;
    var panel = mp.querySelector('[data-tw-mp-panel]');
    var head = mp.querySelector('.tw-mp__head');
    var backBtn = mp.querySelector('[data-tw-mp-back]');
    var backLabel = mp.querySelector('[data-tw-mp-back-label]');
    var root = document.getElementById('tw-mp-c-rod');
    var desktop = window.matchMedia('(min-width: 1024px)');
    var path = [root];
    var opener = null;

    var toggles = function () {
      return document.querySelectorAll('[data-tw-mp-toggle]');
    };
    var colOf = function (el) {
      return el.closest('[data-tw-mp-col]');
    };
    var itemsIn = function (col) {
      return Array.prototype.slice.call(col.querySelectorAll('.tw-mp__item, .tw-mp__saeson'));
    };
    var openerFor = function (col) {
      return mp.querySelector('[data-tw-mp-open="' + col.id + '"]');
    };

    function render(dir) {
      var last = path[path.length - 1];
      mp.querySelectorAll('[data-tw-mp-col]').forEach(function (col) {
        var inPath = path.indexOf(col) !== -1;
        var show = desktop.matches ? inPath : col === last;
        col.hidden = !show;
        col.classList.toggle('is-current', col === last);
        col.classList.remove('tw-ind', 'tw-ud');
      });
      // aria-expanded: kun knapperne, hvis kolonne står i stien
      mp.querySelectorAll('[data-tw-mp-open]').forEach(function (btn) {
        var target = document.getElementById(btn.getAttribute('data-tw-mp-open'));
        btn.setAttribute('aria-expanded', path.indexOf(target) !== -1 ? 'true' : 'false');
      });
      var deep = path.length > 1;
      head.classList.toggle('har-tilbage', deep && !desktop.matches);
      backBtn.hidden = !deep || desktop.matches;
      if (deep) backLabel.textContent = last.getAttribute('data-back-label') || '';
      if (dir && !desktop.matches) {
        last.classList.add(dir === 'ind' ? 'tw-ind' : 'tw-ud');
        last.scrollTop = 0;
      }
    }

    function focusFirst(col) {
      var items = itemsIn(col);
      if (items.length) items[0].focus();
    }

    function openCol(btn, viaKeyboard) {
      var target = document.getElementById(btn.getAttribute('data-tw-mp-open'));
      if (!target) return;
      var level = parseInt(colOf(btn).getAttribute('data-level'), 10) || 1;
      path = path.slice(0, level);
      path.push(target);
      render('ind');
      if (viaKeyboard || !desktop.matches) focusFirst(target);
    }

    function back() {
      if (path.length < 2) return;
      var closed = path.pop();
      render('ud');
      var btn = openerFor(closed);
      if (btn) btn.focus();
    }

    function open(trigger) {
      opener = trigger || null;
      path = [root];
      // Desktop: åbn stien til den side, kunden står på (L1 → L2), så panelet starter dér
      if (desktop.matches) {
        var b1 = root.querySelector('[data-tw-mp-aktiv]');
        var c2 = b1 && document.getElementById(b1.getAttribute('data-tw-mp-open'));
        if (c2) {
          path.push(c2);
          var b2 = c2.querySelector('[data-tw-mp-aktiv]');
          var c3 = b2 && document.getElementById(b2.getAttribute('data-tw-mp-open'));
          if (c3) path.push(c3);
        }
      }
      mp.hidden = false;
      document.documentElement.classList.add('tw-mp-aaben');
      toggles().forEach(function (t) {
        t.setAttribute('aria-expanded', 'true');
      });
      render();
      var start = path[path.length - 1];
      var active = start.querySelector('[aria-expanded="true"], [aria-current="page"]');
      (active || itemsIn(start)[0] || panel).focus();
    }

    function close() {
      if (mp.hidden) return;
      mp.hidden = true;
      document.documentElement.classList.remove('tw-mp-aaben');
      toggles().forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
      if (opener && document.body.contains(opener) && opener.offsetParent !== null) {
        opener.focus();
      } else {
        var visible = Array.prototype.filter.call(toggles(), function (t) {
          return t.offsetParent !== null;
        });
        if (visible[0]) visible[0].focus();
      }
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-tw-mp-toggle]');
      if (t) {
        e.preventDefault();
        if (mp.hidden) open(t);
        else close();
      }
    });

    mp.addEventListener('click', function (e) {
      if (e.target.closest('[data-tw-mp-close]')) {
        close();
        return;
      }
      if (e.target.closest('[data-tw-mp-back]')) {
        back();
        return;
      }
      var btn = e.target.closest('[data-tw-mp-open]');
      if (btn) {
        // Desktop: et nyt klik på den åbne kategori lukker dens kolonne(r)
        if (desktop.matches && btn.getAttribute('aria-expanded') === 'true') {
          var level = parseInt(colOf(btn).getAttribute('data-level'), 10) || 1;
          path = path.slice(0, level);
          render();
          return;
        }
        openCol(btn, e.detail === 0);
        return;
      }
      if (e.target.closest('a[href]')) {
        // Links navigerer; panelet lukkes, så det ikke står åbent ved "tilbage" i browseren
        setTimeout(close, 0);
      }
    });

    mp.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(
          panel.querySelectorAll('a[href], button:not([disabled])'),
          function (el) {
            return el.offsetParent !== null;
          }
        );
        if (!f.length) return;
        var first = f[0];
        var lastEl = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
          e.preventDefault();
          lastEl.focus();
        } else if (!e.shiftKey && document.activeElement === lastEl) {
          e.preventDefault();
          first.focus();
        }
        return;
      }
      var item = e.target.closest('.tw-mp__item, .tw-mp__saeson');
      if (!item) return;
      var col = colOf(item);
      var items = itemsIn(col);
      var i = items.indexOf(item);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        var next = items[(i + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length];
        if (next) next.focus();
      } else if (e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        items[e.key === 'Home' ? 0 : items.length - 1].focus();
      } else if (e.key === 'ArrowRight' && item.hasAttribute('data-tw-mp-open')) {
        e.preventDefault();
        openCol(item, true);
      } else if (e.key === 'ArrowLeft' && col !== root) {
        e.preventDefault();
        if (desktop.matches) {
          var btn = openerFor(col);
          path = path.slice(0, path.indexOf(col));
          render();
          if (btn) btn.focus();
        } else {
          back();
        }
      }
    });

    var onMode = function () {
      if (!mp.hidden) render();
    };
    if (desktop.addEventListener) desktop.addEventListener('change', onMode);
    else if (desktop.addListener) desktop.addListener(onMode);

    // Siden kommer tilbage fra browserens cache: panelet skal være lukket
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) close();
    });
  }

  /* ---------- Kompakt sticky hovedlinje på desktop (Johan 2026-10-24) ---------- */
  function initSticky() {
    var wrap = document.querySelector('.header .tw-hmain-wrap');
    var row = wrap && wrap.querySelector('.tw-hmain');
    if (!row || !window.IntersectionObserver) return;
    var desktop = window.matchMedia('(min-width: 799px)');
    var stuck = false;
    // Wrapperen beholder sin naturlige højde, så siden ikke hopper, når linjen bliver fast
    var lock = function () {
      if (stuck) return;
      wrap.style.height = '';
      wrap.style.height = wrap.offsetHeight + 'px';
    };
    var set = function (on) {
      if (on === stuck) return;
      stuck = on;
      if (on) {
        row.classList.add('is-sticky');
        // næste frame: glid ind fra toppen
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (stuck) row.classList.add('is-inde');
          });
        });
      } else {
        row.classList.remove('is-sticky', 'is-inde');
      }
    };
    lock();
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      set(desktop.matches && !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(wrap);
    window.addEventListener('resize', function () {
      if (!desktop.matches) set(false);
      lock();
    });
  }

  function init() {
    initSticky();
    initKurv();
    initMenupanel();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Måling af fremhævninger (byggemanual 9.4, docs/MAALING-FREMHAEVNINGER.md – Johan 2026-10-24).
   Alle felter med data-tw-promo (agentens felter, forsidens A–D, L1, listekortet, menuens sæsonfelt) sender:
   - tw_view_promotion: feltet har været mindst 50 % synligt i 1 sekund (én gang pr. sidevisning)
   - tw_select_promotion: kunden klikker på feltet eller et link i det
   som Shopify custom events. Temaet sender intet til Google; custom pixlen "Toolworld fremhævninger"
   (docs/pixel-fremhaevninger.js) abonnerer og sender view_promotion/select_promotion til GA4, kun efter samtykke. */
(function () {
  if (!window.IntersectionObserver) return;
  var publish = function (navn, el) {
    var a = window.Shopify && window.Shopify.analytics;
    if (!a || typeof a.publish !== 'function') return;
    a.publish(navn, {
      creative_slot: el.getAttribute('data-tw-slot') || '',
      promotion_id: el.getAttribute('data-tw-promo-id') || '',
      promotion_name: el.getAttribute('data-tw-promo-navn') || '',
      item_id: el.getAttribute('data-tw-id') || ''
    });
  };
  var sete = new WeakSet();
  var timere = new WeakMap();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (sete.has(el)) return;
      if (e.isIntersecting && e.intersectionRatio >= 0.5) {
        if (!timere.has(el)) {
          timere.set(el, window.setTimeout(function () {
            sete.add(el);
            io.unobserve(el);
            publish('tw_view_promotion', el);
          }, 1000));
        }
      } else if (timere.has(el)) {
        window.clearTimeout(timere.get(el));
        timere.delete(el);
      }
    });
  }, { threshold: [0, 0.5] });
  var observeAll = function (scope) {
    (scope || document).querySelectorAll('[data-tw-promo]').forEach(function (el) {
      if (!el.__twPromo) {
        el.__twPromo = true;
        io.observe(el);
      }
    });
  };
  observeAll();
  // Felter, der kommer til senere (fx listevisningen, der hentes med section_id)
  if (window.MutationObserver) {
    var venter = null;
    new MutationObserver(function (muts) {
      if (venter) return;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) {
          venter = window.setTimeout(function () {
            venter = null;
            observeAll();
          }, 400);
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-tw-promo]');
    if (el && e.target.closest('a, button')) publish('tw_select_promotion', el);
  }, true);
})();
